import { useColorModeValue } from '@chakra-ui/react'
import { useClient } from './ClientProvider'
import { useFeature } from '../features/FeaturesProvider'
import { Feature } from './features.gen'

/** Chat presentation read from the client config. */
export function useChatAppearance() {
  const { config } = useClient()
  const newUi = useFeature(Feature.NEW_UI)
  const chatLogoUrl = useColorModeValue(
    config?.theme.chat?.logoUrl,
    config?.theme.chat?.logoDarkModeUrl ?? config?.theme.chat?.logoUrl,
  )
  return {
    branding: config?.theme.branding,
    logoUrl: newUi ? chatLogoUrl : undefined,
    brandLogoUrl: useColorModeValue(
      config?.theme.branding.logoUrl,
      config?.theme.branding.logoDarkModeUrl ?? config?.theme.branding.logoUrl,
    ),
    showWordmark: config?.theme.chat?.showWordmark,
    // Without the new UI the main chat gets its agent icon like any other agent.
    welcomeMark: newUi ? config?.theme.chat?.welcomeMark : undefined,
    welcomeLogoHeight: config?.theme.chat?.welcomeLogoHeight ?? 44,
    sidebarWidth: config?.theme.layout.sidebarWidth ?? '280px',
  }
}
